import React from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

import type { EgsRoomRow } from '../tabs/egs/previousEgs';
import type { RoomAssetLink } from '../tabs/packageOptions/types';

import CopyEgsRoomsRow, { type EgsRoomsChange, type EgsSkipChange } from './CopyEgsRoomsRow';

type CopyEgsRoomsStepProps = {
  nothingToCopy: boolean;
  onRoomsChange: EgsRoomsChange;
  onSkipChange: EgsSkipChange;
  rooms: Array<RoomAssetLink>;
  rows: Array<EgsRoomRow>;
  roomsByNameKey: Record<string, Array<string>>;
  skippedRows: ReadonlySet<string>;
};

export default function CopyEgsRoomsStep({
  nothingToCopy,
  onRoomsChange,
  onSkipChange,
  rooms,
  rows,
  roomsByNameKey,
  skippedRows,
}: CopyEgsRoomsStepProps) {
  return (
    <>
      <Typography sx={{ mt: 2 }} variant="subtitle2">
        Rooms for each extra guest surcharge
      </Typography>
      <Typography color="text.secondary" variant="body2">
        Read from the Salesforce names. Check them, and pick the rooms where none matched. Skip one whose room this
        Opportunity doesn&apos;t have: it won&apos;t be copied.
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Salesforce name</TableCell>
            <TableCell>Guests</TableCell>
            <TableCell>Rooms</TableCell>
            <TableCell>Skip</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <CopyEgsRoomsRow
              key={row.key}
              onRoomsChange={onRoomsChange}
              onSkipChange={onSkipChange}
              allRooms={rooms}
              row={row}
              rooms={roomsByNameKey[row.key]}
              skipped={skippedRows.has(row.key)}
            />
          ))}
        </TableBody>
      </Table>
      {nothingToCopy && (
        <Typography color="error" sx={{ mt: 1 }} variant="body2">
          Every extra guest surcharge is skipped. Untick Extra Guest Surcharges on What to copy instead.
        </Typography>
      )}
    </>
  );
}
